module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.6fcc926.ttf";